<!--
 @description 服务监控-应用列表页
 @author xiehan
 @date 2018/10/10
-->
<template>
  <div class="serverAppList__content">
    <g-back :history="history"></g-back>
    <div v-for="item in appList"
      :key="item.appName"
      class="each-app"
      @click="jumpToDetail(item.appName, item.group)"
      :class="{ 'bg-green': item.level < 1 || item.level > 4,
      'bg-yellow': item.level >= 3 && item.level <= 4,
      'bg-red': item.level >= 1 && item.level <= 2}">
      <span v-text="item.appName" :title="item.appName" class="each-app-title"></span>
      <img :src="bgImg">
      <ul class="each-app-content">
        <li>
          <span v-text="$t('serverMonitor.appearAlarm')+item.alarmCount+$t('serverMonitor.unit')"></span>
        </li>
        <li>
          <span v-text="$t('serverMonitor.collectTarget')+item.merit+$t('serverMonitor.unit')"></span>
        </li>
      </ul>
    </div>
    <div v-text="$t('common.noData')" style="text-align: center" v-show="appList.length === 0"></div>
  </div>
</template>

<script>
import SiteListBiz from '@/logic/cmdb/cmdbBiz'
import ServerMonitorBiz from '@/logic/intelligentMonitor/serverMonitorBiz'

export default {
  data () {
    return {
      history: [],
      appList: [],
      bgImg: require('@/assets/image/monitor_bg.png'),
      siteList: {}
    }
  },
  methods: {
    getSiteList () {
      SiteListBiz.siteList({perPageCount: 500}).then((data) => {
        let list = {}
        data.dataList.map((item) => {
          list[item.siteCode] = item.name
        })
        this.siteList = list
        this.setHistory(this.$route.query.group)
      })
    },
    getAppList (group) {
      ServerMonitorBiz.getAppList({ group: group, siteCode: this.$route.query.siteCode }).then((d) => {
        this.appList = d
      })
    },
    setHistory (group) {
      this.history = []
      this.history = [{ name: `${this.$t('serverMonitor.serverMonitor')}(${this.siteList[this.$route.query.siteCode]})` },
        { name: group }]
    },
    jumpToDetail (app, group) {
      this.$router.push({ name: 'serverDetail', query: { app: app, group: group, siteCode: this.$route.query.siteCode } })
    }
  },
  components: {},
  watch: {
    $route (to, from) {
      if (to.name === 'serverAppList' && from.name === 'serverMonitor') {
        this.getAppList(this.$route.query.group)
        this.setHistory(this.$route.query.group)
      }
    }
  },
  mounted () {
    this.getAppList(this.$route.query.group)
    this.getSiteList()
  }
}
</script>

<style scoped>
  .each-app {
    width: 300px;
    height: 130px;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    margin: 0 20px 20px 0;
    padding: 6px 0 0 15px;
    cursor: pointer;
    position: relative;
  }
  .each-app img {
    position: absolute;
    right: 0;
    bottom: 0px;
  }
  .each-app-title {
    font-size: 34px;
    height: 70px;
    margin-right: 15px;
    word-wrap: break-word;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .each-app-content {
    margin: 10px 0 0 20px;
  }
  .bg-green {
    background: #52b947;
  }
  .bg-yellow {
    background: #d4cf00;
  }
  .bg-red {
    background: #f27373;
  }
</style>
